// Random String helper
const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export default length =>
  Array.from({ length })
    .map(() => chars[Math.floor(Math.random() * chars.length)])
    .join('');
